function NotAcceptingApplications() {
  return (
    <span className="warning-text">
      <i className="fa fa-exclamation-triangle" style={{paddingRight: ".25rem"}}></i>Not currently accepting new applications
    </span>
  );
}

export default NotAcceptingApplications;